<!-- This component has been deprecated since it lacks necessary accessibility features. -->
<!-- Prefer using base-radio-checkbox.vue instead. -->

<template>
  <div class="checkbox" :class="[typeClass, textColorClass, checkColorClass, cssClasses, hasErrors, disabledClass, { 'checkbox--no-text': noTextClass }]">
    <input
      :id="isFor"
      v-model="checked"
      autocomplete="false"
      :value="val"
      :name="isFor"
      type="checkbox"
      class="checkbox__hidden"
      :disabled="isDisabled"
      @change="change">
    <label
      :for="isFor"
      class="checkbox__label"
      v-html="text">
      <slot></slot>
    </label>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    value: { type: [Boolean, Array], default: false },
    val: { type: null, required: false, default: null },
    isFor: {
      type: String,
      default: () => _.uniqueId('checkbox-')
    },
    size: {
      type: String,
      default: 'medium'
    },
    textColor: {
      type: String,
      default: 'black'
    },
    checkColor: {
      type: String,
      default: 'blue'
    },
    text: {
      type: String,
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    checkedProxy: false
  }),
  computed: {
    typeClass() {
      return `checkbox--${this.size}`
    },
    textColorClass() {
      return `checkbox--text-${this.textColor}`
    },
    checkColorClass() {
      return `checkbox--check-${this.checkColor}`
    },
    disabledClass() {
      return this.isDisabled ? 'checkbox--is-disabled' : null
    },
    hasErrors() {
      if(this.errors.length > 0) {
        return 'checkbox--has-errors'
      }
      return ''
    },
    noTextClass() {
      return this.text === null && this.$slots.default === undefined
    },
    checked: {
      get () {
        return this.value
      },
      set (val) {
        this.checkedProxy = val
      }
    }
  },
  methods: {
    change(e) {
      this.$emit('input', this.checkedProxy)
    }
  }
}
</script>

<style lang="scss">
.checkbox {
  display: flex;
  align-items: center;
}

.checkbox--is-disabled {
  pointer-events: none;
  opacity: .8;
}

.checkbox__hidden {
  display: none;
}

.checkbox__label {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }

  &:before {
    content: '';
    flex-shrink: 0;
    margin-right: measure(quarter);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 80%;
    border: 2px solid;
    transition: background-image 200ms;
  }

  &:after {
    content: '' ;
    flex-shrink: 0;
    position: absolute;
    top: 50%;
    background-image: url("data:image/svg+xml,%3Csvg width='30' height='28' viewBox='0 0 30 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.034 27.39L0 16.842l3.3-3.424 7.27 6.95L26.279.8 30 3.764z' fill='%2344B1FA' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    transform: translateY(-50%) scale(0);
    opacity: 0;
    transition: transform 120ms ease-in, opacity 180ms ease-in;
  }
}

.checkbox--no-text .checkbox__label::before {
  margin-right: 0;
}

.checkbox--text-gray .checkbox__hidden + .checkbox__label {
  color: color(disabled-item);
}

.checkbox--text-blue .checkbox__hidden + .checkbox__label {
  color: color(enabled-item);
}

.checkbox--check-gray .checkbox__hidden + .checkbox__label:before {
  border-color: color(disabled-item);
}

.checkbox--check-blue .checkbox__hidden + .checkbox__label:before {
  border-color: color(enabled-item);
}

.checkbox--is-disabled  .checkbox__hidden + .checkbox__label {
  &::before {
    border-color: #A2A2A2;
  }

  &::after {
    background-image: url("data:image/svg+xml,%3Csvg width='30' height='28' viewBox='0 0 30 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.034 27.39L0 16.842l3.3-3.424 7.27 6.95L26.279.8 30 3.764z' fill='%23A2A2A2' fill-rule='evenodd'/%3E%3C/svg%3E");
  }
}

.checkbox--small .checkbox__hidden + .checkbox__label {
  @include body-smaller;

  &:before {
    width: 1.125rem;
    height: 1.125rem;
    border-width: 1px;
  }

  &:after {
    left: .22rem;
    width: .7rem;
    height: .7rem;
  }
}

.checkbox--medium .checkbox__hidden + .checkbox__label {
  &:before {
    width: 1.25rem;
    height: 1.25rem;
  }

  &:after {
    left: .238rem;
    width: 0.8rem;
    height: 0.8rem;
  }
}

.checkbox--large .checkbox__hidden + .checkbox__label {
  @include body;

  &:before {
    width: 1.875rem;
    height: 1.875rem;
  }

  &:after {
    left: .4rem;
    width: 1.1rem;
    height: 1.1rem;
  }
}

.checkbox__hidden:checked + .checkbox__label {
  &::before {
    border-color: color(enabled-item);
  }

  &:after {
    opacity: 1;
    transform: translateY(-50%) scale(1);
    transition: transform 120ms ease-out, opacity 160ms ease-out;
  }
}

.checkbox--is-disabled .checkbox__hidden:checked + .checkbox__label {
  &::before {
    border-color: #A2A2A2;
  }
}

.checkbox--has-errors .checkbox__hidden + .checkbox__label {
  color: color(text-red);

  &:before {
    border-color: color(text-red);
  }
}
</style>
